var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"formGroup"},[_c('label',{staticClass:"block text-sm font-medium text-gray-700 mb-1",attrs:{"for":_vm.name}},[_vm._v(_vm._s(_vm.label))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }